<template>
  <!-- insert app config form -->
  <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
    <div class="p-text-right">
        <Button
          label="Add New Version"
          @click="isNewAppVersionFormVisible = !isNewAppVersionFormVisible"
          class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" /> 
    </div>
  </div>

  <transition name="expand">
    <div v-show="isNewAppVersionFormVisible" class="p-grid p-jc-center p-p-4">
      <div class="card p-col-12 p-md-9 p-mx-auto p-p-4">
        <div class="p-grid">
          <div class="p-col-6 p-md-3">
            <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select OS"
              v-model="newAppVersionForm.os" :options="osList" optionLabel="name" optionValue="code" />
          </div>
          <div class="p-col-6 p-md-3">
            <span class="p-float-label">
              <InputText class="p-col-12" id="package" type="text" v-model="newAppVersionForm.package" />
              <label for="package">Package</label>
            </span>
          </div>
          <div class="p-col-4 p-md-2">
            <span class="p-float-label">
              <InputText class="p-col-12" id="app_version_code" type="number" v-model="newAppVersionForm.app_version_code" />
              <label for="app_version_code">App Version Code</label>
            </span>
          </div>
          <div class="p-col-4 p-md-2">
            <span class="p-float-label">
              <InputText class="p-col-12" id="os_version_code" type="number" v-model="newAppVersionForm.os_version_code" />
              <label for="os_version_code">OS Version Code</label>
            </span>
          </div>
          <div class="p-col-4 p-md-2 p-text-left">
            <Checkbox id="is_mandatory" :binary="true" v-model="newAppVersionForm.is_mandatory" />
            <label for="is_mandatory" class="p-ml-2">Required</label>
          </div>
        </div>
        <div class="p-grid p-mt-2">
          <div class="p-col-12 p-md-6">
            <span class="p-float-label">
              <InputText class="p-col-12" id="title" type="text" v-model="newAppVersionForm.title" />
              <label for="title">Title</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-pl-2 p-text-left">
            Release Date
            <Calendar id="release_date" class="p-pl-2" v-model="newAppVersionForm.release_date"
                :showTime="true" dateFormat="dd/mm/yy" hourFormat="HH:mm" />
          </div>
          <div class="p-col-12 p-md-12 p-mt-2">
            <span class="p-float-label">
              <Textarea class="p-col-12" id="description" type="text" rows="2" :autoResize="true" v-model="newAppVersionForm.description" />
              <label for="description">Description</label>
            </span>
          </div>
        </div>
        <div class="p-grid p-jc-end p-m-0 p-pt-2">
          <Button @click="addAppVersion()" label="Add App Version" class="p-button p-button-info" />
        </div>
      </div>
    </div>
  </transition>

  <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

  <div class="p-grid">
    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
      <DataTable v-show="appVersionList !== null && appVersionList.length > 0" :paginator="true" :rows="25" :rowHover="true"
        :value="appVersionList" dataKey="id" filterDisplay="menu" >
          <Column field="id" header="#" sortable style="width:5%"></Column>
          <Column field="os" header="OS" style="width:10%">
            <template #body="{data}">
              {{osName(data.os)}}
              <br/>
              <sub><i>{{data.package}}</i></sub>
            </template>
          </Column>
          <Column field="app_version_code" header="App Version Code" sortable style="width:10%; text-align:center;">
            <template #body="{data}">
              {{data.app_version_code}}
            </template>
          </Column>
          <Column field="os_version_code" header="OS Version Code" sortable style="width:10%; text-align:center;">
            <template #body="{data}">
              {{data.os_version_code}}
            </template>
          </Column>
          <Column field="is_mandatory" header="Required" style="width:5%; text-align:center;">
            <template #body="{data}">
              <Checkbox v-model="data.is_mandatory" :binary="true" :disabled="true" />
            </template>
          </Column>
          <Column header="Info" style="width:35%">
            <template #body="{data}">
              <div v-html="getFormattedComment(data.title)" class="p-text-bold"></div>
              <br/>
              <div v-html="getFormattedComment(data.description)"></div>
            </template>
          </Column>
          <Column field="release_date" header="Release Date" dataType="date" class="p-text-center" style="width:10%; line-height: 1.25rem;">
            <template #body="{data}">
              <div v-html="getFormattedDate(data.release_date)" style="width:100%"></div>
            </template>
            <template #editor="{}"></template>
          </Column>
          <Column header="" style="width:10%" bodyStyle="text-align:left;">
            <template #body="item">
              <div style="">
                <Button label="" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                  @click="editAppVersion(item.data, item.index)" />
                <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                  @click="deleteAppVersion(item.data.id)" />
              </div>
            </template>
            <template #editor="{}"></template>
          </Column>
      </DataTable>
    </div>
  </div>

  <!-- app version edit modal -->
  <Dialog v-model:visible="updateAppVersionForm.visible"
    :header="updateAppVersionForm.appversion ? updateAppVersionForm.appversion.title : ''"
    :modal="true" class="p-fluid p-col-8">

    <div class="card p-col-12 p-md-12 p-mx-auto p-p-2">
        <div class="p-grid">
          <div class="p-col-6 p-md-3">
            <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select OS"
              v-model="updateAppVersionForm.appversion.os" :options="osList" optionLabel="name" optionValue="code" />
          </div>
          <div class="p-col-6 p-md-3">
            <span class="p-float-label">
              <InputText class="p-col-12" id="package" type="text" v-model="updateAppVersionForm.appversion.package" />
              <label for="package">Package</label>
            </span>
          </div>
          <div class="p-col-4 p-md-2">
            <span class="p-float-label">
              <InputText class="p-col-12" id="app_version_code" type="number" v-model="updateAppVersionForm.appversion.app_version_code" />
              <label for="app_version_code">App Version Code</label>
            </span>
          </div>
          <div class="p-col-4 p-md-2">
            <span class="p-float-label">
              <InputText class="p-col-12" id="os_version_code" type="number" v-model="updateAppVersionForm.appversion.os_version_code" />
              <label for="os_version_code">OS Version Code</label>
            </span>
          </div>
          <div class="p-col-4 p-md-2 p-text-left">
            <Checkbox id="is_mandatory" :binary="true" v-model="updateAppVersionForm.appversion.is_mandatory" />
            <label for="is_mandatory" class="p-ml-2">Required</label>
          </div>
        </div>
        <div class="p-grid p-mt-3">
          <div class="p-col-12 p-md-6">
            <span class="p-float-label">
              <InputText class="p-col-12" id="title" type="text" v-model="updateAppVersionForm.appversion.title" />
              <label for="title">Title</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-pl-2 p-text-left">
            Release Date
            <Calendar id="release_date" class="p-pl-2" v-model="updateAppVersionForm.appversion.release_date"
                :showTime="true" dateFormat="dd/mm/yy" hourFormat="HH:mm" />
          </div>
          <div class="p-col-12 p-md-12 p-mt-3">
            <span class="p-float-label">
              <Textarea class="p-col-12" id="description" type="text" rows="2" :autoResize="true"
              v-model="updateAppVersionForm.appversion.description" />
              <label for="description">Description</label>
            </span>
          </div>
        </div>
        <div class="p-grid p-jc-end p-m-0 p-pt-2">
          <Button
            @click="updateAppVersion(updateAppVersionForm.appversion, updateAppVersionForm.index)" 
            label="Update App Version"
            class="p-button p-button-info" />
        </div>
      </div>
  </Dialog>

  <Divider align="center" class="p-mt-6">
    <div class="p-d-inline-flex p-ai-center">
      <b>About</b>
    </div>
  </Divider>

  <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
    <div class="p-d-flex">
      <i class="fa fa-info p-mr-3"></i> Uygulama versiyonları buradan yönetilir.
      <br/> Google Play veya App Store'da yeni versiyon yayınlandıkça bu sayfa üzerinden uygulamadaki MyTeam ekranında güncelleme uyarısı gösterilmek üzere güncel versiyon bilgisi girilir.
      <br/> Güncel Versiyon uyarısı alan cihazlar bu bilgiyi localde saklar ve her açılışta localden bu bilgiyi gösterir. Tekrardan servis çağrısı ile güncel versiyona bakılmaz.
      <br/> Bundan dolayı yeni versiyon bilgisi girilirken dikkat edilmelidir. Marketlerde tüm kullanıcı kitlesine güncelleme açıldıktan sonra burada girilmelidir. 
    </div>
  </div>
</template>

<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressBar from 'primevue/progressbar'
import Divider from 'primevue/divider'
import Checkbox from 'primevue/checkbox'
import Calendar from 'primevue/calendar'
import Dialog from 'primevue/dialog'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import moment from 'moment'

export default {
  name: 'ConfigApp',
  emits: ["loginResult", "pageLoaded"],
  components: {
    Dropdown, InputText, Textarea, Button, DataTable, ProgressBar, Dialog, Column, Divider, Checkbox, Calendar
  },
  data() {
    return {
      osList: [
        { code: 'and', name: 'Android'},
        { code: 'ios', name: 'iOS'}
      ],
      newAppVersionForm: {},
      updateAppVersionForm: {
        appversion: null,
        visible: false,
        index: 0
      },
      isNewAppVersionFormVisible: false,
      isItemListLoading: false,
      appVersionList: [],
      editingRows: [],
      filters: {
        'os': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'key': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'value': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'comment': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'last_updated_date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]}
      }
    }
  },
  beforeMount() {
      var page = {
          title: "App Versions"
      }
      this.$emit('pageLoaded', page)
  },
  mounted() {
    this.loadAppVersions()
  },
  methods: {
    osName(osValue) {
      var value = ''
      this.osList.forEach(item => {
        if(item.code === osValue)
          value = item.name
      })

      return value;
    },
    loadAppVersions() {
      let self = this,
          cookies = self.$cookies,
          toast = self.$toast,
          token = cookies.get('token');

      self.isItemListLoading = true
      self.$http.get('api/config/appversion', {
        headers: {
          'authorization': 'Bearer ' + token
          }
      })
      .then(function (response) {
          self.isItemListLoading = false
          if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
            cookies.set('token', response.headers['refresh-token']);
              self.appVersionList = response.data.items
          } else if(response.data.kod === Const.KOD.oturumSonlandi) {
            self.$router.push('/login')
          } else {
            toast.add({severity:'warn', summary: 'Loading app versions failed', detail:response.data.mesaj, life: 3000});
          }
      })
      .catch(function (err) {
        self.isItemListLoading = false
        toast.add({severity:'error', summary: 'Error', detail:err});
        console.log(err)
      });
    },
    onRowEditSave(event) {
      let { newData, index } = event;

      let self = this,
          configId = newData.id,
          newConfig = {
              id: configId,
              os: newData.os,
              key: newData.key,
              value: newData.value,
              comment: newData.comment
          },
          toast = self.$toast,
          toastMessage = null,
          cookies = self.$cookies,
          token = cookies.get('token');
      
      if(isEmpty(newConfig.os)) {
        toastMessage = 'OS is not selected!'
      } else if(isEmpty(newConfig.key)) {
        toastMessage = 'Key is empty!'
      } else if(isEmpty(newConfig.value)) {
        toastMessage = 'Value is empty!'
      }

      if(!isEmpty(toastMessage)) {
          toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
          return
      }

      self.$http.put('api/config/app/'+configId, newConfig, {
          headers: {
              'authorization': 'Bearer ' + token
          }
      })
      .then(function (response) {
          if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
            cookies.set('token', response.headers['refresh-token']);
            
            self.appVersionList[index] = response.data.item;

            toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
          } else {
            toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
          }
      })
      .catch(function (err) {
          console.log(err)
          toast.add({severity: 'error', summary: 'Error', detail: err});
      });
    },
    addAppVersion() {
      let self = this,
          toast = self.$toast,
          newAppVersionForm = self.newAppVersionForm,
          toastMessage = null,
          cookies = self.$cookies,
          token = self.$cookies.get('token');

      if(isEmpty(newAppVersionForm.os)) {
        toastMessage = 'OS is not selected!'
      } else if(isEmpty(newAppVersionForm.package)) {
        toastMessage = 'Package is empty!'
      } else if(isEmpty(newAppVersionForm.app_version_code)) {
        toastMessage = 'App Version Code is empty!'
      } else if(isEmpty(newAppVersionForm.os_version_code)) {
        toastMessage = 'OS Version Code is empty!'
      } else if(isEmpty(newAppVersionForm.title)) {
        toastMessage = 'Title is empty!'
      } else if(isEmpty(newAppVersionForm.description)) {
        toastMessage = 'Description is empty!'
      } else if(isEmpty(newAppVersionForm.release_date)) {
        toastMessage = 'Release Date is empty!'
      }

      if(!isEmpty(toastMessage)) {
          toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
          return
      }

      self.$http.post('api/config/appversion', newAppVersionForm, {
          headers: {
              'authorization': 'Bearer ' + token
          }
      })
      .then(function (response) {
        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
          cookies.set('token', response.headers['refresh-token']);
          let newAddedItem = response.data.item
          
          self.appVersionList.push(newAddedItem)

          toast.add({severity:'success', summary: 'Success', detail: 'App version added successfully.', life: 3000});

          self.newAppVersionForm = {}
        } else {
          console.log(response)
          toast.add({severity:'warn', summary: 'App version insert failed', detail:response.data.mesaj, life: 3000});
        }
      })
      .catch(function (err) {
        console.log(err)
        toast.add({severity: 'error', summary: 'Error', detail: err});
      });
    },
    editAppVersion(appVersion, currentItemIndex) {
      let updateAppVersionForm = this.updateAppVersionForm

      updateAppVersionForm.appversion = appVersion;
      updateAppVersionForm.visible = true;
      updateAppVersionForm.index = currentItemIndex
      console.log(this.updateAppVersionForm, currentItemIndex)
    },
    async updateAppVersion(newData, index) {
      let self = this,
        appVersionId = newData.id,
        newAppVersion = {
          os: newData.os,
          package: newData.package,
          app_version_code: newData.app_version_code,
          os_version_code: newData.os_version_code,
          is_mandatory: newData.is_mandatory,
          release_date: newData.release_date,
          title: newData.title,
          description: newData.description
        },
        toast = self.$toast,
        toastMessage = null,
        cookies = self.$cookies,
        token = cookies.get('token');

      if(isEmpty(newAppVersion.os)) {
        toastMessage = 'OS is not selected!'
      } else if(isEmpty(newAppVersion.package)) {
        toastMessage = 'Package is empty!'
      } else if(isEmpty(newAppVersion.app_version_code)) {
        toastMessage = 'App Version Code is empty!'
      } else if(isEmpty(newAppVersion.os_version_code)) {
        toastMessage = 'OS Version Code is empty!'
      } else if(isEmpty(newAppVersion.title)) {
        toastMessage = 'Title is empty!'
      } else if(isEmpty(newAppVersion.description)) {
        toastMessage = 'Description is empty!'
      } else if(isEmpty(newAppVersion.release_date)) {
        toastMessage = 'Release Date is empty!'
      }

      if(!isEmpty(toastMessage)) {
          toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
          return
      }

      try {
        let response = await self.$http.put(`api/config/appversion/${appVersionId}`, newAppVersion, {
          headers: {
            'authorization': 'Bearer ' + token
          }
        })

        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
          cookies.set('token', response.headers['refresh-token']);
          
          self.appVersionList[index] = response.data.item;

          toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});

          this.updateAppVersionForm = {
              appversion: null,
              visible: false,
              index: 0
          }
        } else {
            toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
        }
      } catch(error) {
        console.log(error)
        toast.add({severity: 'error', summary: 'Error', detail: error});
      }
    },
    deleteAppVersion(appVersionId) {
      let self = this,
          toast = self.$toast,
          cookies = self.$cookies,
          token = self.$cookies.get('token');
      
      this.$confirm.require({
          message: 'Are you sure you want to delete this app version permanently?',
          header: 'Delete',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Delete',
          rejectLabel: 'Cancel',
          accept: () => {
            self.$http.delete('api/config/appversion/'+appVersionId, {
              headers: {
                'authorization': 'Bearer ' + token
              }
            })
            .then(function (response) {
              if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                cookies.set("token", response.headers['refresh-token']);

                self.loadAppVersions()

                toast.add({severity:'success', summary: 'Success', detail: 'App version deleted successfully.', life: 3000});
              } else {
                console.log(response)
                toast.add({severity:'warn', summary: 'Delete app version failed', detail:response.data.mesaj, life: 3000});
              }
            })
            .catch(function (err) {
              console.log(err)
              toast.add({severity: 'error', summary: 'Error', detail: err});
            });
          },
          reject: () => {
          }
      });
    },
    getFormattedDate(logDate) {
      return moment(new Date(logDate)).format('DD/MM/YYYY HH:mm');
    },
    getFormattedComment(comment) {
      return !isEmpty(comment) ? comment.replaceAll('\n', '<br/>') : null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-customers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>